import { SET_LAYOUT } from './types';

export function setLayout(payload) {
	return {
		type: SET_LAYOUT,
		payload
	};
}
